import "../../../../src/pages/design/design-guidelines-styles.css";
import { ColorSwatch } from "../../../../src/components/ColorSwatch";
import { magma } from 'react-magma-dom';
import * as React from 'react';
export default {
  ColorSwatch,
  magma,
  React
};